import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AppConstants } from '../AppConstants';
import { AuthService } from '../service/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
  selector: 'app-company-profile',
  templateUrl: './company-profile.component.html',
  styleUrls: ['./company-profile.component.css']
})
export class CompanyProfileComponent implements OnInit {
  showFacilityFeatures = true;
  user;
  removable = true;
  amenities = [];
  holidays = [];
  rules = [];
  originalRules = [];
  showAddNewAmenitiesButton = true;
  showAddNewHolidaysButton = true;
  showAddNewRulesButton = true;
  amenityFormGroup: FormGroup;
  holidayFormGroup: FormGroup;
  ruleFormGroup: FormGroup;
  googleMapsLinkFormGroup: FormGroup;
  tenantDetails;
  tenantImagesResponse;
  noOfImages;
  images = [];
  previewImages = [];
  defaultImageIndex;
  defaultImageIndexBeforeUpdate;
  facilityTypes;
  cities = ["Adoni","Agartala","Agra","Ahmednagar","Aizawl","Ajmer","Akola","Alappuzha","Aligarh","Allahabad","Alwar","Amaravati","Ambala","Ambattur",
  "Ambernath","Amravati","Amritsar","Amroha","Anand","Anantapur","Arrah","Asansol","Aurangabad","Avadi","Bagaha","Baharampur","Bahraich","Bally","Bangalore",
  "Baranagar","Barasat","Bardhaman","Bareily","Bathinda","Begusarai","Belgaum","Bellary","Berhampur","Bettiah","Bhagalpur","Bhalswa Jahangir Pur","Bharatpur",
  "Bhatpara","Bhavnagar","Bhilai","Bhilwara","Bhimavaram","Bhind","Bhiwandi","Bhiwani","Bhopal","Bhubaneswar","Bhuj","Bhusawal","Bidar","Bidhan Nagar","Bihar Sharif",
  "Bijapur","Bilaspur","Bikaner","Bokaro","Bulandshahr","Burhanpur","Buxar","Chandigarh","Chandrapur","Chennai","Chapra","Chittoor","Coimbatore","Cuttack","Danapur",
  "Darbhanga","Davanagere","Dehradun","Dehri","Delhi","Deoghar","Dewas","Dhanbad","Dharmavaram","Dhule","Dindigul","Durg","Durgapur","Eluru","Erode","Etawah",
  "Faridabad","Farrukhabad","Fatehpur","Firozabad","Gandhidham","Gandhinagar","Gaya","Ghaziabad","Gopalpur","Gorakhpur","Gudivada","Gulbarga","Guna","Guntakal",
  "Guntur","Gurgaon","Guwahati","Gwalior","Hajipur","Haldia","Hapur","Haridwar","Hindupur","Hospet","Howrah","Hubballi-Dharwad","Hugli and Chinsurah","Hyderabad",
  "Ichalkaranji","Imphal","Indore","Jabalpur","Jaipur","Jalandhar","Jalgaon","Jalna","Jamalpur","Jammu","Jamnagar","Jamshedpur","Jaunpur","Jehanabad","Jhansi",
  "Jodhpur","Junagadh","Kadapa","Kakinada","Kalyan-Dombivali","Kamarhati","Kanpur","Karaikudi","Karawal Nagar","Karimnagar","Karnal","Katihar","Kavali","Khammam",
  "Khandwa","Kharagpur","Khora","Kirari Suleman Nagar","Kishanganj","Kochi","Kolhapur","Kolkata","Kollam","Korba","Kota","Kottayam","Kozhikode","Kulti","Kurnool",
  "Latur","Loni","Lucknow","Ludhiana","Machilipatnam","Madanapalle","Madhyamgram","Madurai","Mahesana","Maheshtala","Malda","Malegaon","Mangalore","Mango","Mathura",
  "Mau","Meerut","Mumbai","Mira-Bhayandar","Miryalaguda","Mirzapur","Moradabad","Morena","Morvi","Motihari","Munger","Murwara","Muzaffarnagar","Muzaffarpur","Mysore",
  "Nadiad","Nagarcoil","Naihati","Nanded","Nandyal","Nangloi Jat","Narasaraopet","Nashik","Navi Mumbai","Navi Mumbai Panvel Raigad","Nellore","New Delhi","Nizamabad",
  "Noida","North Dumdum","Ongole","Orai","Ozhukarai","Pali","Pallavaram","Panchkula","Panihati","Panipat","Panvel","Parbhani","Patiala","Patna","Pimpri-Chinchwad",
  "Proddatur","Puducherry","Pune","Purnia","Rae Bareli","Raichur","Raiganj","Raipur","Rajahmundry","Rajkot","Rajpur Sonarpur","Ramagundam","Rampur","Ranchi","Ratlam",
  "Raurkela Industrial Township","Rewa","Rohtak","Rourkela","Sagar","Saharanpur","Saharsa","Salem","Sambalpur","Sambhal","Sangli-Miraj & Kupwad","Sasaram","Satara",
  "Satna","Secunderabad","Serampore","Shahjahanpur","Shimla","Shivamogga","Shivpuri","Sikar","Siliguri","Singrauli","Sirsa","Siwan","Solapur","Sonipat","South Dumdum",
  "Srinagar","Sri Ganganagar","Srikakulam","Sultan Pur Majra","Surat","Surendranagar Dudhrej","Suryapet","Tadepalligudem","Tadipatri","Tenali","Thane","Thanjavur",
  "Thiruvananthapuram","Thoothukudi","Thrissur","Tiruchirappalli","Tirunelveli","Tirupati","Tiruppur","Tiruvottiyur","Tumkur","Udaipur","Ujjain","Ulhasnagar","Uluberia",
  "Unnao","Vadodara","Varanasi","Vasai-Virar","Vellore","Vijayawada","Vijayanagaram","Visakhapatnam","Warangal","Yamunanagar"
   ];

  facilityDetailsFormGroup: FormGroup;

  radioButtonColor: ThemePalette = 'primary';

  defaultImageInTenantDetailsHeader = "../../assets/img/2.png";

  ruleEditMode: boolean = false;

  // date = new FormControl(new Date());
  monthNames = ["","Jan", "Feb", "Mar", "Apr", "May", "June",
  "July", "Aug", "Sep", "Oct", "Nov", "Dec"];
  public Editor = ClassicEditor;

  public editorConfig = {
    toolbar: [
      'bold',
      'italic',
      '|',
      'bulletedList',
      'numberedList',
      '|',
      'link',
      '|',
      'undo',
      'redo'
    ]
  };


  constructor(private authService: AuthService, private _sanitizer: DomSanitizer, private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.user = JSON.parse(sessionStorage.getItem(AppConstants.SESSION_STORAGE_CURRENT_USER_CONTEXT));

    //console.log("CP User", this.user );

    this.amenityFormGroup = new FormGroup({
      amenityNameFormControl: new FormControl('', [
        Validators.required
      ])
    });

    this.holidayFormGroup = new FormGroup({
      holidayFormControl: new FormControl('', [
        Validators.required
      ])
    });

    this.ruleFormGroup = new FormGroup({
      ruleFormControl: new FormControl('', [
        Validators.required
      ])
    });

    this.googleMapsLinkFormGroup = new FormGroup({
      googleMapsLinkFormControl: new FormControl('', [
        Validators.required
      ])
    });

    this.facilityDetailsFormGroup = new FormGroup({
      facilityNameFormControl: new FormControl('', [
        Validators.required
      ]),
      facilityTypeFormControl: new FormControl('', [
        Validators.required
      ]),
      facilityDescriptionFormControl: new FormControl('', [
        Validators.required
      ]),
      addressLine1FormControl: new FormControl('', [
        Validators.required
      ]),
      addressLine2FormControl: new FormControl('', [
        Validators.required
      ]),
      pincodeFormControl: new FormControl('', [
        Validators.required
      ]),
      cityFormControl: new FormControl('', [
        Validators.required
      ]),
      phoneNumber1FormControl: new FormControl('', [
        Validators.required,
        Validators.pattern("^[0-9]*$"),
        Validators.minLength(10),
        Validators.maxLength(10)
      ]),
      phoneNumber2FormControl: new FormControl('', [
        Validators.pattern("^[0-9]*$"),
        Validators.minLength(10),
        Validators.maxLength(10)
      ]),
      phoneNumber3FormControl: new FormControl('', [
        Validators.pattern("^[0-9]*$"),
        Validators.minLength(10),
        Validators.maxLength(10)
      ]),
      emailFormControl: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[\w._%+\-]+@[\w.\-]+\.[a-zA-Z]{2,}(,\s*[\w._%+\-]+@[\w.\-]+\.[a-zA-Z]{2,})*$/)
      ]),
    });
    //console.log("Role Id CP ", this.user.roleId);
    if(this.user.roleId == 1)
    {
        console.log("Tenant Id ", AppConstants.SESSION_STORAGE_TENANTID);
        this.user.tenantId = AppConstants.SESSION_STORAGE_TENANTID;
        console.log("Tenant Id ", this.user.tenantId);
        console.log("user", this.user);
    }
    this.authService.getTenantDetailsBYTenantID(this.user.tenantId).subscribe(
      (response: any) => {
        //console.log('Tenant Details Response', response);
        //console.log('Google Maps Link', response.googleMapsLink);

        this.tenantDetails = response;
        this.googleMapsLinkFormGroup.patchValue({
          googleMapsLinkFormControl: response.googleMapsLink
        });
        //console.log(this.tenantDetails);
      }
    );

    this.authService.getTenantHolidaysByTenantId(this.user.tenantId).subscribe(
      (response : any[]) => {
        if(response.length > 0) {
          response.forEach(holiday => {
            const date = holiday.date.split("-");
            const day = date[2];
            const month = this.monthNames[+date[1]];
            const displayDate = day  + " " + month;
            this.holidays.push({holidayId: holiday.id, displayDate: displayDate, holidayDate: holiday.date});
          });
        }
      }
    );

    this.authService.getTenantAmenitiesByTenantId(this.user.tenantId).subscribe(
      (response : any[]) => {
        if(response.length > 0) {
          response.forEach(amenity => this.amenities.push({amenityId: amenity.id, amenityName: amenity.amenityName}));
        }
      }
    );

    this.getTenantRules();

    this.authService.getFacilityDetails().subscribe(
      response => {
        this.facilityTypes = response;
      }
    );

    this.getTenantImagesByTenantId(this.user.tenantId);
  }

  getTenantRules() {
    this.authService.getTenantRulesByTenantId(this.user.tenantId).subscribe(
      (response: any[]) => {
        this.rules.length = 0;
        if(response.length > 0) {
          response.forEach(rule => {
            this.rules.push(rule);
          });
          this.originalRules = JSON.parse(JSON.stringify(this.rules))
        }
      }
    );
  }

  get facilityDetailsFormControls() {
    return this.facilityDetailsFormGroup.controls;
  }

  getTenantImagesByTenantId(tenantId) {
    this.authService.getTenantImagesByTenantId(tenantId).subscribe(
      (response: any) => {
        //console.log(response);
        if(response.status == 200) {
          this.tenantImagesResponse = response.body;
          this.noOfImages = response.body.images.length;
          this.defaultImageIndex = this.tenantImagesResponse.defaultImageIndex;
          this.defaultImageIndexBeforeUpdate = this.tenantImagesResponse.defaultImageIndex;
          this.images.length = 0;
          for(let image of this.tenantImagesResponse.images) {
            this.images.push(image);
          }
        }
      },
      (error) => {
        this.snackBar.open('Failed to load images!', '', {
                                                        duration: 5000,
                                                        verticalPosition: 'bottom',
                                                        horizontalPosition: 'center',
                                                        panelClass: ['snackbar-error']
                                                      });


      }
    );
  }

  onClickEditIcon() {
    this.showFacilityFeatures=false;
  }

  onCancelClick() {
    this.showFacilityFeatures=true;
  }

  clickedAddNewAmenitiesButton() {
    this.showAddNewAmenitiesButton = false;
  }

  clickedAddNewHolidaysButton() {
    this.showAddNewHolidaysButton = false;
  }

  clickedAddNewRulesButton() {
    this.showAddNewRulesButton = false;
  }

  createNewAmenity() {
    this.authService.createNewAmenity(this.user.tenantId, this.amenityFormGroup.get('amenityNameFormControl').value).subscribe(
      (response: any) => {
        //console.log(response);
        this.showAddNewAmenitiesButton = true;
        this.amenities.push({amenityId: response.id, amenityName: response.amenityName});
        this.amenityFormGroup.reset();
      }
    );
  }

  createNewHoliday() {
    const date = new Date(this.holidayFormGroup.get('holidayFormControl').value);
    const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
    // const month = date.getMonth();
    // const day = date.getDate();
    // const year = date.getFullYear();
    // const holidayDate = year + "-" + month + "-" + day;
    this.authService.createNewHoliday(this.user.tenantId, formattedDate).subscribe(
      (response: any) => {
        //console.log(response);
        this.showAddNewHolidaysButton = true;
        const date = response.date.split("-");
        const day = date[2];
        const month = this.monthNames[+date[1]];
        const displayDate = day  + " " + month;
        this.holidays.push({holidayId: response.id, displayDate: displayDate, holidayDate: response.date});
        this.holidayFormGroup.reset();
      },
      (error: HttpErrorResponse) => {
        if(error.error.errors[0].code == 2205) {
          alert(error.error.errors[0].message);
        } else if(error.error.errors[0].code == 2206) {
          alert(error.error.errors[0].message);
        }
      }
    );
  }

  createNewRule(ruleIndex) {
    //console.log(ruleIndex);
    this.authService.createNewRule(this.user.tenantId, "", Number(ruleIndex), this.ruleFormGroup.get('ruleFormControl').value).subscribe(
      (response: any) => {
        //console.log(response);
        this.showAddNewRulesButton = true;
        this.ruleFormGroup.reset();
        this.getTenantRules();
      }
    );
  }

  updateGoogleMapsLink() {
    const googleMapsLink = this.googleMapsLinkFormGroup.get('googleMapsLinkFormControl').value;
    //console.log(googleMapsLink);
    this.authService.updateGoogleMapsLinkByTenantId(this.user.tenantId, googleMapsLink).subscribe(
      (response: any) => {
        //console.log(response);
      }
    );
  }

  deleteAmenity(amenity) {
    this.authService.deleteAmenityByAmenityId(amenity.amenityId).subscribe(
      (response: any) => {
        this.amenities = this.amenities.filter(amenity => amenity.amenityId !== response.id);
      }
    );
  }

  deleteHoliday(holiday) {
    this.authService.deleteHolidayByHolidayId(holiday.holidayId).subscribe(
      (response: any) => {
        this.holidays = this.holidays.filter(holiday => holiday.holidayId !== response.id);
      }
    );
  }

  deleteRule(ruleId) {
    this.authService.deleteRuleByRuleId(ruleId).subscribe(
      (response: any) => {
        this.getTenantRules();
      }
    );
  }

  selectValueChangeForFacilityType() {
    console.log('selectValueChangeForFacilityType clicked');
  }

  selectValueChangeForCity() {
    console.log('selectValueChangeForCity clicked');
  }

  onSaveClicked() {
    const facilityDetails = {
      tenantName: this.facilityDetailsFormGroup.get("facilityNameFormControl").value,
      tenantType: "Customer",
      description: this.facilityDetailsFormGroup.get("facilityDescriptionFormControl").value,

      googleMapsLink:
          this.googleMapsLinkFormGroup.get(
            'googleMapsLinkFormControl'
          ).value,
      address: {
        addressLine1: this.facilityDetailsFormGroup.get("addressLine1FormControl").value,
        addressLine2: this.facilityDetailsFormGroup.get("addressLine2FormControl").value,
        city: this.facilityDetailsFormGroup.get("cityFormControl").value,
        pinCode: this.facilityDetailsFormGroup.get("pincodeFormControl").value,
        country: "India"
      },
      tenantCategoryId: Number(this.facilityDetailsFormGroup.get("facilityTypeFormControl").value),
      contactPhoneNumber1: this.facilityDetailsFormGroup.get("phoneNumber1FormControl").value,
      contactPhoneNumber2: this.facilityDetailsFormGroup.get("phoneNumber2FormControl").value,
      contactPhoneNumber3: this.facilityDetailsFormGroup.get("phoneNumber3FormControl").value,
      email: this.facilityDetailsFormGroup.get("emailFormControl").value
    }
    //console.log(facilityDetails);

   //console.log('Facility Details Payload 1', facilityDetails);
   /* console.log(
     'Current Google Link',
     this.googleMapsLinkFormGroup.get('googleMapsLinkFormControl').value
   ); */

    this.authService.updateTenantByTenantId(this.tenantDetails.id, facilityDetails).subscribe(
      (response: any) => {
        //console.log(response);
        this.tenantDetails = response;
        console.log("facility details updated successfully");
        //console.log(this.defaultImageIndex);
        this.defaultImageIndex = this.defaultImageIndexBeforeUpdate;
        this.showFacilityFeatures = true;
        this.snackBar.open('Company Profile saved successfully!', '', {
                                                                duration: 5000,
                                                                verticalPosition: 'bottom',
                                                                horizontalPosition: 'center',
                                                                panelClass: ['snackbar-success']
                                                              });
        this.authService.getTenantImagesByTenantId(this.user.tenantId).subscribe(
          (getTenantImagesResponse: any) => {
            if(getTenantImagesResponse.status == 204) {
              // No Content response received i.e images are not created
              var i = 0;
              var length = this.previewImages.length;
              for(i = 0; i < length; i++) {
                if(i == 0) {
                  this.authService.createTenantImages(this.user.tenantId, this.defaultImageIndex, this.previewImages[i].file).subscribe(
                    (createTenantImageResponse: any) => {

                       this.getTenantImagesByTenantId(this.user.tenantId);
                      this.previewImages.length = 0;

                      this.showFacilityFeatures = true;    // close edit screen

                      console.log('Tenant Images created successfully.');
                      this.snackBar.open('Company Profile saved successfully!', '', {
                                                                      duration: 5000,
                                                                      verticalPosition: 'bottom',
                                                                      horizontalPosition: 'center',
                                                                      panelClass: ['snackbar-success']
                                                                    });

                    },
                    (error) => {
                      this.snackBar.open('Failed to save company profile!', '', {
                                                                    duration: 5000,
                                                                    verticalPosition: 'bottom',
                                                                    horizontalPosition: 'center',
                                                                    panelClass: ['snackbar-error']
                                                                  });


                    }
                  );
                } else {
                  this.authService.updateTenantImagesByTenantId(this.user.tenantId, this.defaultImageIndex, this.previewImages[i].file).subscribe(
                    (updateImageResponse: any) => {

                      this.getTenantImagesByTenantId(this.user.tenantId); //refreshing image list
                      this.previewImages.length = 0;
                      this.showFacilityFeatures = true;
                      console.log('Tenant Images updated successfully.');
                      this.snackBar.open('Company Profile saved successfully!', '', {
                                                                              duration: 5000,
                                                                              verticalPosition: 'bottom',
                                                                              horizontalPosition: 'center',
                                                                              panelClass: ['snackbar-success']
                                                                            });
                    },
                    (error) => {
                    this.snackBar.open('Failed to save images!', '', {
                                                                        duration: 5000,
                                                                        verticalPosition: 'bottom',
                                                                        horizontalPosition: 'center',
                                                                        panelClass: ['snackbar-error']
                                                                      });
                    }
                  );
                }
              }
            } else if(getTenantImagesResponse.status == 200) {
              var i = 0;
              var length = this.previewImages.length;
              if(length > 0) {
                for(i = 0; i < length; i++) {
                  this.authService.updateTenantImagesByTenantId(this.user.tenantId, this.defaultImageIndex, this.previewImages[i].file).subscribe(
                    (updateImageResponse: any) => {
                      this.getTenantImagesByTenantId(this.user.tenantId);
                      this.previewImages.length = 0;
                      this.showFacilityFeatures = true;
                      console.log('Tenant Images updated successfully.');
                      this.snackBar.open('Company Profile saved successfully!', '', {
                                                                              duration: 5000,
                                                                              verticalPosition: 'bottom',
                                                                              horizontalPosition: 'center',
                                                                              panelClass: ['snackbar-success']
                                                                            });
                    },
                    (error) => {
                    this.snackBar.open('Failed to save images!', '', {
                                                                        duration: 5000,
                                                                        verticalPosition: 'bottom',
                                                                        horizontalPosition: 'center',
                                                                        panelClass: ['snackbar-error']
                                                                      });
                    }
                  );
                }
              } else {
                this.authService.updateTenantImagesByTenantIdWithNoImage(this.user.tenantId, this.defaultImageIndex).subscribe(
                  (updateImageResponse: any) => {
                    this.getTenantImagesByTenantId(this.user.tenantId);
                    console.log('Tenant Images updated successfully.');
                    this.snackBar.open('Company Profile saved successfully!', '', {
                                                                            duration: 5000,
                                                                            verticalPosition: 'bottom',
                                                                            horizontalPosition: 'center',
                                                                            panelClass: ['snackbar-success']
                                                                          });

                  },
                  (error) => {
                  this.snackBar.open('Failed to save images!', '', {
                                                                      duration: 5000,
                                                                      verticalPosition: 'bottom',
                                                                      horizontalPosition: 'center',
                                                                      panelClass: ['snackbar-error']
                                                                    });

                  }
                );
              }
            }
          },
          (error) => {
              this.snackBar.open('Failed to save company profile!', '', {
                                                                  duration: 5000,
                                                                  verticalPosition: 'bottom',
                                                                  horizontalPosition: 'center',
                                                                  panelClass: ['snackbar-error']
                                                                });
          }
        )
        //this.showFacilityFeatures=true;
      }
    );
  }

  // selectDefaultImageIndex(index) {
  //   this.defaultImageIndex = index;
  // }

  onFileUploaded(event) {

    const totalImages =
        this.images.length + this.previewImages.length;

      if (totalImages >= 5) {

        this.snackBar.open(
          'You can upload a maximum of 5 images.',
          '',
          {
            duration: 5000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center',
            panelClass: ['snackbar-error']
          }
        );

        event.target.value = '';

        return;
      }

    if (event.target.files && event.target.files[0]) {

      const file = event.target.files[0];

      // 1 MB = 1024 * 1024 bytes
      const maxSize = 1024 * 1024;

      if (file.size > maxSize) {

        this.snackBar.open(
          'Image size cannot exceed 1 MB.',
          '',
          {
            duration: 5000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center',
            panelClass: ['snackbar-error']
          }
        );

        event.target.value = '';

        return;
      }

      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {

        this.previewImages.push({
          file: file,
          dataUrl: reader.result
        });

        this.snackBar.open(
          'Image selected successfully. Click Save to upload.',
          '',
          {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center',
            panelClass: ['snackbar-success']
          }
        );
      };

      reader.onerror = () => {

        this.snackBar.open(
          'Failed to read image.',
          '',
          {
            duration: 5000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center',
            panelClass: ['snackbar-error']
          }
        );
      };
    }
  }

  defaultImageIndexChange(value) {
    this.defaultImageIndexBeforeUpdate = value;
  }

  getImageToShowInTenantDetailsHeader() {
    if(this.images.length > 0) {
      //console.log('defaultImageIndex', this.defaultImageIndex);
      return this.images[this.defaultImageIndex];
    } else {
      return this.defaultImageInTenantDetailsHeader;
    }
  }

  toggleEditRule() {
    this.ruleEditMode = !this.ruleEditMode;
    if(!this.ruleEditMode) {
      this.rules.length = 0;
      this.originalRules.forEach(r => {
          this.rules.push(r);
      });
    }
  }

  showPopup = false;
  toBeDeleteRule;
  deleteRuleConfirm(id) {
    //console.log("Rule to be delete : " + id)
    this.toBeDeleteRule = id;
    this.showPopup = true;
  }

  confirmDelete(): void {
    // Your delete logic
    this.showPopup = false;
    this.deleteRule(this.toBeDeleteRule)
  }

  cancelPopup(): void {
    this.showPopup = false;
  }

  updateRules() {
    this.authService.updateTenantRules(this.rules, this.user.tenantId).subscribe(
      (response: any[]) => {
        this.ruleEditMode = false;
        this.getTenantRules();
      }
    );
  }

  cancelSave() {
    this.showAddNewRulesButton = true;
  }

  showDeleteImagePopup:boolean = false;
  imageToBeDelete;

  confirmDeleteImage(image){
    //console.log(image);
    this.imageToBeDelete = image;
    this.showDeleteImagePopup = true;
  }

  deleteImage() {
    let imageResponse = JSON.parse(JSON.stringify(this.tenantImagesResponse));
    let selectedImage = this.tenantImagesResponse.images[this.defaultImageIndex];
    imageResponse.images = imageResponse.images.filter(img => img !== this.imageToBeDelete);
    imageResponse.defaultImageIndex = imageResponse.images.indexOf(selectedImage);
    if(imageResponse.defaultImageIndex == -1) {
      imageResponse.defaultImageIndex = 0;
    }
    imageResponse.totalImagesCount = imageResponse.images.length;
    //console.log(imageResponse.images);
    //console.log(this.imageToBeDelete);
    this.authService.deleteTenantImages(this.user.tenantId, this.imageToBeDelete.split('/').pop(), imageResponse).subscribe(
      (response: any[]) => {
        this.showDeleteImagePopup = false;
        this.getTenantImagesByTenantId(this.user.tenantId);

        this.snackBar.open('Image deleted successfully!', '', {
                                                            duration: 5000,
                                                            verticalPosition: 'bottom',
                                                            horizontalPosition: 'center',
                                                            panelClass: ['snackbar-success']
                                                          });
      },
      (error) => {
                    this.snackBar.open('Failed to delete image!', '', {
                                                                        duration: 5000,
                                                                        verticalPosition: 'bottom',
                                                                        horizontalPosition: 'center',
                                                                        panelClass: ['snackbar-error']
                                                                      });
                                                                      }
    );
  }

  closeImagePopup() {
    this.showDeleteImagePopup = false;
  }

}
